export const DEFAULT_TEXTAREA_RESIZABLE_MAX_ROWS = 18

export const DEFAULT_TEXTAREA_ROWS = 3

export const QA_NAME_TEXTAREA_CONTEXT = 'textarea'
